<template>
    <form method="get"
          :action="searchPageUrl"
          class="w-full md:w-auto flex flex-row-reverse justify-between items-center border border-gray-500">
        <input type="search"
               name="query"
               autocomplete="off"
               class="bg-white pl-3 pr-10 py-2 text-base color-black placeholder-opacity-75 focus:outline-none focus:bg-white text-white focus:text-black w-full h-14"
               v-model="query"
               placeholder="Søk artikler, kronikker, rapporter og mer"
               @focus="toggleFocus(true)"
               @blur="toggleFocus(false)" />
        <button class="absolute opacity-75 pl-2 pr-4 text-gray-500"
                type="submit"
                @focus="toggleFocus(true)"
                @blur="toggleFocus(false)">
            <font-awesome-icon icon="search" />
        </button>
    </form>
</template>

<script>
export default {
    props: {
        searchPage: {
            type: Object
        },
        className: {
            type: String,
            'default': ''
        },
        defaultFocus: {
            type: Boolean,
            'default': false
        }
    },
    data() {
        let q = '';
        if (this.$route.query && this.$route.query.query) {
            q = this.$route.query.query;
        }

        return {
            query: q,
            hasFocus: this.defaultFocus,
            searchPageUrl: (this.searchPage && this.searchPage.value ? this.searchPage.value.url : '/sok/'),
            mobiletoggle: false
        };
    },
    methods: {
        toggleFocus(state) {
            this.hasFocus = state;
        }
    }
};
</script>
